exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".file-viewer{display:inline-block;overflow:auto;max-width:calc(100vw - 80px);max-height:calc(90vh - 140px);display:flex;justify-content:flex-start;align-items:flex-start;transition:.5s}.file-viewer .loading-placeholder{position:relative;min-width:400px;min-height:400px}", ""]);

